export default "__VITE_ASSET__fijKxDhp__"